import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetIntegrationDocument,
  GetIntegrationQuery,
  GetIntegrationQueryVariables,
  GetIntegrationsDocument,
  GetIntegrationsQuery,
  GetIntegrationsQueryVariables,
  IntegrationFieldsFragment
} from '~/api/graphql';

export const getIntegrations = async () =>
  queryData<GetIntegrationsQuery, GetIntegrationsQueryVariables, IntegrationFieldsFragment[]>(
    client,
    { query: GetIntegrationsDocument },
    (data) => data?.integrations || []
  );

export const getIntegration = async (id: string) =>
  queryData<GetIntegrationQuery, GetIntegrationQueryVariables, IntegrationFieldsFragment>(
    client,
    { query: GetIntegrationDocument, variables: { id: id } },
    (data) => data?.integration
  );

export const loadIntegrations: LoaderFunction = () =>
  loadQuery(getIntegrations(), { suppressAuthErrors: true });

export const loadIntegration: LoaderFunction = ({ params }) =>
  loadQuery(getIntegration(params.id || ''));
